import { type ReactNode } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Sun, Moon, LogIn, BookOpen } from "lucide-react";
import { useTheme } from "../lib/theme";
import { Ticker } from "./Ticker";
import { useQuery } from "@tanstack/react-query";
import { apiList} from "../lib/api";



/** Public, sidebar-less shell for the national dashboard shown to unauthenticated
 *  visitors: header + marquee + dashboard, with a Sign-in button. */
export function PublicShell({ cycle, setCycle, children }:
  { cycle: number; setCycle: (y: number) => void; children?: ReactNode }) {
  const { theme, toggle } = useTheme();
  const nav = useNavigate();
// const CYCLES = [2025, 2024, 2023];
  const CYCLES =  useQuery({ queryKey: ["admin-cycles"], queryFn: () => apiList<any>("/api/cycles/") }).data?.map((c: any) => c.year) ?? [2025, 2024, 2023];

  const hide = (e: React.SyntheticEvent<HTMLImageElement>) =>
    ((e.target as HTMLImageElement).style.display = "none");

  return (
    <div className="shell public">
      <header className="topbar">
        <div className="logos">
          <img src="/nbs-logo.svg" alt="NBS" onError={hide} />
          <img src="/ilo-logo.svg" alt="ILO" onError={hide} />
          <span className="sep" />
          <span className="wordmark">Social Protection<small>SDG 1.3.1 statistics</small></span>
        </div>
        <span className="spacer" />
        <NavLink to="/page/instruction" className="header-link" title="Instructions">
          <BookOpen size={15} /> <span className="header-link-label">Instructions</span>
        </NavLink>
        <select value={cycle} onChange={(e) => setCycle(Number(e.target.value))} aria-label="Reporting year">
          {CYCLES.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <button className="icon-btn" onClick={toggle} aria-label="Toggle theme"
          title={theme === "dark" ? "Light mode" : "Dark mode"}>
          {theme === "dark" ? <Sun size={15} /> : <Moon size={15} />}
        </button>
        <button className="accent signin-btn" onClick={() => nav("/login")}>
          <LogIn size={15} /> Sign in
        </button>
      </header>
      <div className="ticker-bar"><Ticker cycle={cycle} /></div>
      <main className="main">{children}</main>
    </div>
  );
}
